exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3KMFHrz3oU1eAr{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between}._2uqlb7eVAteKVd,._21NegEWyntugiF{margin:8px 0;border-radius:4px;width:132px;height:72px}._2uqlb7eVAteKVd{background-size:contain;background-repeat:no-repeat;background-position:50%;box-shadow:none}._2uqlb7eVAteKVd._3z8gId_zZlNSY0{opacity:.25}._2uqlb7eVAteKVd:hover{-webkit-filter:saturate(85%) brightness(85%);filter:saturate(85%) brightness(85%)}._2uqlb7eVAteKVd:active{-webkit-filter:saturate(70%) brightness(70%);filter:saturate(70%) brightness(70%)}._2uqlb7eVAteKVd._1TAeKQAkeIywxP{box-shadow:0 0 0 2px #fff,0 0 0 4px #0079bf;-webkit-filter:none;filter:none}._2uqlb7eVAteKVd._1TAeKQAkeIywxP:hover{box-shadow:0 0 0 2px #fff,0 0 0 4px #5ba4cf;-webkit-filter:none;filter:none}._2uqlb7eVAteKVd._1TAeKQAkeIywxP:active{box-shadow:0 0 0 2px #fff,0 0 0 4px #055a8c;-webkit-filter:none;filter:none}._2s-khz3RZVkbsM{margin:8px 0 0;width:100%}._2f9jWPHNYvYLR2{width:100%}.hlHPG8ecAbF-2p{font-size:12px;display:block;text-align:center;color:#5e6c84;margin-top:4px}", ""]);

// exports
exports.locals = {
	"covers": "_3KMFHrz3oU1eAr",
	"cover": "_2uqlb7eVAteKVd",
	"add": "_21NegEWyntugiF",
	"uploading": "_3z8gId_zZlNSY0",
	"selected": "_1TAeKQAkeIywxP",
	"remove": "_2s-khz3RZVkbsM",
	"upload": "_2f9jWPHNYvYLR2",
	"feedback": "hlHPG8ecAbF-2p"
};